module.exports = __webpack_public_path__ + "static/media/tail-spin.a75a5f09.svg";